import axiosInstance from './axios';
import backendUrl from '../backendUrl';
import { token } from './auth';

const baseUrl = `${backendUrl}/api/economy`;

const setConfig = () => ({
  headers: { 'x-auth-token': token },
});

/** Award prices, caps and rates — so the client never hardcodes an economy number. */
const getConfig = async (): Promise<any> => {
  const response = await axiosInstance.get(`${baseUrl}/config`);
  return response.data;
};

const getWallet = async (): Promise<any> => {
  const response = await axiosInstance.get(`${baseUrl}/wallet`, setConfig());
  return response.data;
};

const getLedger = async (currency?: string, cursor?: string | null): Promise<any> => {
  const params = new URLSearchParams();
  if (currency && currency !== 'all') params.set('currency', currency);
  if (cursor) params.set('cursor', cursor);
  const query = params.toString();
  const response = await axiosInstance.get(
    `${baseUrl}/ledger${query ? `?${query}` : ''}`,
    setConfig()
  );
  return response.data;
};

/**
 * Give an award. The idempotency key means a retry after a dropped response
 * returns the original award instead of charging the user twice.
 */
const giveAward = async (
  postId: string,
  awardKey: string,
  anonymous: boolean,
  idempotencyKey: string
): Promise<any> => {
  const response = await axiosInstance.post(
    `${baseUrl}/awards`,
    { postId, awardKey, anonymous },
    { headers: { ...setConfig().headers, 'Idempotency-Key': idempotencyKey } }
  );
  return response.data;
};

const getPostAwards = async (postId: string): Promise<any> => {
  const response = await axiosInstance.get(`${baseUrl}/posts/${postId}/awards`);
  return response.data;
};

const convertPointsToCoins = async (coins: number): Promise<any> => {
  const response = await axiosInstance.post(`${baseUrl}/coins/convert`, { coins }, setConfig());
  return response.data;
};

const economyService = {
  getConfig,
  getWallet,
  getLedger,
  giveAward,
  getPostAwards,
  convertPointsToCoins,
};

export default economyService;
